import React from 'react';

import { Heading, Subheading, Paragraph } from '../Typography';

type BuilderTextProps = {
  variant: string;
  text: string;
  headingLevel: 'h1' | 'h2' | 'h3';
  size: '1' | '2' | '3' | '4' | '5';
  isUpperCase: boolean;
  elementTypeOverride?: React.ElementType | keyof JSX.IntrinsicElements;
};

const getVariantName = ({
  variant,
  size,
  isUpperCase,
  headingLevel,
}: BuilderTextProps) => {
  if (variant === 'heading') {
    return headingLevel;
  }

  return `${variant}${size}${isUpperCase ? 'Uppercase' : ''}`;
};

export function BuilderText(props: BuilderTextProps) {
  const { variant, text, elementTypeOverride } = props;
  const variantName = getVariantName(props);
  const elementType = elementTypeOverride ?? null;

  if (variant === 'heading') {
    return (
      <Heading variant={variantName} as={elementType}>
        {text}
      </Heading>
    );
  }

  if (variant === 'subHeading') {
    return (
      <Subheading variant={variantName} as={elementType}>
        {text}
      </Subheading>
    );
  }

  return (
    <Paragraph variant={variantName} as={elementType}>
      {text}
    </Paragraph>
  );
}
